import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Col, Form, Row } from "antd";
import { useFormContentBlocker, useI18n } from "../../../../../contexts";
const FormContentBlockerFieldTechnicalTcfVendors = (param)=>{
    let { dropdownVendors, children } = param;
    const { __, _i } = useI18n();
    const { tcfPurposes = [] } = useFormContentBlocker();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
            children: (param)=>{
                let { getFieldValue } = param;
                const criteria = getFieldValue("criteria");
                return criteria === "tcfVendors" && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Item, {
                            label: __("Connected TCF Vendors"),
                            required: true,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "tcfVendors",
                                    noStyle: true,
                                    rules: [
                                        {
                                            type: "array",
                                            required: true,
                                            message: __("Please provide at least one vendor!")
                                        }
                                    ],
                                    children: dropdownVendors
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    children: _i(__("A content blocker is displayed until the user has agreed to {{strong}}all{{/strong}} necessary TCF vendors and purposes that would be used by loading the content. You must define all TCF vendors and purposes that are loaded based on legitimate interest or consent as soon as the user wants to see the blocked content."), {
                                        strong: /*#__PURE__*/ _jsx("strong", {})
                                    })
                                }),
                                children
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Form.Item, {
                            label: __("Required TCF purposes"),
                            required: true,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    noStyle: true,
                                    name: "tcfPurposes",
                                    rules: [
                                        {
                                            type: "array",
                                            required: true,
                                            message: __("Please provide at least one purpose!")
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                                        style: {
                                            marginTop: 6
                                        },
                                        children: /*#__PURE__*/ _jsx(Row, {
                                            children: tcfPurposes.map((param)=>{
                                                let { name, id } = param;
                                                return /*#__PURE__*/ _jsx(Col, {
                                                    span: 12,
                                                    children: /*#__PURE__*/ _jsx(Checkbox, {
                                                        value: id,
                                                        children: name
                                                    })
                                                }, `purpose-${id}`);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: __('Defined which purposes of all connected TCF vendors must be allowed (by consent or legitimate interest) for the content blocker to unblock the content. At a minimum, "Store and/or access information on a device" should be given if cookies or similar information are read/written. In terms of data economy according to the GDPR, you should specify further purposes if, for example, only personalized advertising is displayed and therefore unblocking without consent/legitimate interest to this purpose has no practical use.')
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
export { FormContentBlockerFieldTechnicalTcfVendors };
